import {
  AbilityBuilder,
  type CreateAbility,
  createMongoAbility,
  type MongoAbility,
} from "@casl/ability"
import { z } from "zod/v4"

import { trainingSubject } from "@/lib/auth/subjects/training"
import type { TUser } from "./models/user"
import { permissions } from "./permissions"
import { userSubject } from "./subjects/user"

export * from "./models/user"
export * from "./roles"
export * from "./subjects"

const appAbilitiesSchema = z.union([
  userSubject,
  trainingSubject,
  z.tuple([z.literal("manage"), z.literal("all")]),
])

type TAppAbilities = z.infer<typeof appAbilitiesSchema>

export type TAppAbility = MongoAbility<TAppAbilities>
export const createAppAbility = createMongoAbility as CreateAbility<TAppAbility>

export function defineAbilityFor(user: TUser) {
  const builder = new AbilityBuilder(createAppAbility)

  if (typeof permissions[user.role] !== "function") {
    throw new Error(`Permissions for role ${user.role} not found.`)
  }

  permissions[user.role](user, builder)

  const ability = builder.build({
    detectSubjectType(subject) {
      return subject.__typename
    },
  })

  ability.can = ability.can.bind(ability)
  ability.cannot = ability.cannot.bind(ability)

  return ability
}
